import * as React from "react";
import Select from "react-select";


class CustomSelect extends React.PureComponent<any, any> {
  render() {
    return (
        <div className="filter-select">
            {
                this.props.label !== undefined ? <label className="my-0">{this.props.label}</label> 
                : undefined 
            }
            <Select
                placeholder={this.props.placeholder}
                className={this.props.className}
                options={this.props.options}
                value={this.props.value}
                onChange={this.props.onChange}
            />
        </div>
    );
  }
}

export default CustomSelect;
